import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { id: "underline" }, [
      _createElementVNode("path", {
        id: "vector",
        d: "M3.66663 13.6673H12.3333M4.33329 2.33398V8.02364C4.33329 10.4042 5.97492 12.334 7.99996 12.334C10.025 12.334 11.6666 10.4042 11.6666 8.02364V2.33398",
        stroke: "currentColor",
        "stroke-linecap": "square"
      })
    ], -1)
  ])))
}
export default { render: render }